import React from 'react';

export const ConnectionAccountName = ({ provider, username }) => {
  if (typeof username !== 'string' || !username.trim()) return null;
  const name = username.trim().replace(/^@+/, '');
  const label = { stake: 'Stake account', discord: 'Discord account', kick: 'Kick account' }[provider];
  return <div className="connection-account-summary" data-testid={`${provider}-account-summary`}>
    <span className="connection-account-label" data-testid={`${provider}-account-label`}>{label}</span>
    <p className="connection-account-name" data-testid={`${provider}-connection-username`}>{name}</p>
  </div>;
};